<template>
    <div class="section" id='sec-intro'>
        <p class="info-text">
            I am a PostDoc Fellow at Harvard, working with <a href="http://www.fernandaviegas.com/about">Prof. Fernanda Viégas</a> and <a href="https://www.bewitched.com/about.html">Prof. Martin Wattenberg</a> in the <a href="https://insight.seas.harvard.edu" class="url">Insight and Interaction Lab</a>. I am also a teaching assistant at Harvard Business School.

            My research interests include
            <b style="font-weight: bold">Data Visualization</b> and
            <b style="font-weight: bold">Human-Computer Interaction</b>. I focus on designing and
            evaluating intelligent and interactive systems to ease the creation of data
            visualizations for communication, data analysis, and data-driven decision-making. 

            <br /><br />

            I received my Ph.D. from the Hong Kong University of Science and
            Technology (HKUST) in 2022, where I worked in the <a href="http://vis.cse.ust.hk/" class="url">VisLab</a> under the supervision of <a href="http://huamin.org/" class="url">Prof. Huamin Qu</a>. My PhD was awarded <a href="https://cerg1.ugc.edu.hk/hkpfs/index.html" class="url"
                >Hong Kong PhD Fellowship Scheme</a
            >, <a href="https://www.microsoft.com/en-us/research/academic-program/phd-fellowship/people/" class="url"
                >Microsoft Research PhD Fellowship</a
            >, <a href="https://cse.hkust.edu.hk/News/BestDissertation2021-22/#:~:text=We%20are%20pleased%20to%20announce%20that%20the%20recipient%20of%20the,of%20Visualizations%20for%20Data%20Communication." class="url">HKUST CSE Best PhD Dissertation Award</a
            >, and <a href="https://ieeecs-media.computer.org/tc-media/sites/49/2023/10/09182418/Aoyu_Wu_2023_VGTC_Visualization_Dissertation_Award.pdf" class="url">IEEE VGTC Visualization Doctoral Dissertation Award</a
            >. I appreciate interdisciplinary learning and thinking. I obtained my Bachelor degree of
            Engineering from HKUST with the
            <a href="http://publish.ust.hk/aa_medal/index.asp" class="url"
                ><span style="">Academic Achievement Medal (top 1%)</span></a
            >, with <span class="text-highlight">double major</span> in Electronic Engineering and
            in Computer Science and <span class="text-highlight">triple minor</span> in Mathematics,
            in Big Data Technology, and in Humanities
            <a href="https://www.shss.ust.hk/ug/minor/hm/award/" class="url">(honoured)</a>.
            
            <br /><br />

            I contribute systems that make social impacts through real-world deployment.
            My work has attracted three Hong Kong ITF/GRF funds with over 4M HKD.
            Systems that I developed have became a <a class="url" href="https://hkust.edu.hk/news/community-and-sustainability/hkust-launches-sustainable-smart-campus-living-lab-inspiring"
                >featured demo at HKUST</a>, patented for commercialization, recognized by industrial (i.e., <a href="https://www.hkictawards.hk/" class="url">Hong Kong ICT Awards</a> and <a href="https://www.info.gov.hk/gia/general/201911/23/P2019112300065.htm?fontSize=1" class="url">Asia-Pacific ICT Awards</a>) and academic awards (i.e., CHI 2022 Honorable Mention), and received wide media coverage (e.g., <a href="https://www.scmp.com/news/hong-kong/education/article/3003997/making-long-queues-thing-past-goal-two-computing-science" class="url">Southern China Morning Post</a>, <a href="http://www.takungpao.com.hk/231106/2019/0430/281981.html" class="url">Tai Kung Pao</a>).
                
            <br /><br />
            
            I am an adventurer and have traveled to more than 30 countries. 

            <!-- My other research is patented and adopted for use in a commercial product. -->


            <!-- In the
            <a href="http://vis.cse.ust.hk/" class="url">HKUST VisLab</a>,
            I lead the <a href="http://pulse.ust.hk/" class="url">Pulse of HKUST</a> (smart campus
            initiative) R&D team and am affiliated with the
            <a href="http://vis.cse.ust.hk/groups/multimodal-vis/" class="url"
                >Multimodal Analysis</a
            > and 
                        <a href="http://vis.cse.ust.hk/groups/ai4vis/" class="url"
                >AI4VIS</a
            >
            research interest group. -->

            <br /><br />



            <br /><br />

            <!-- I appreciate interdisciplinary learning and thinking. I obtained my Bachelor degree of
            Engineering from HKUST with the
            <a href="http://publish.ust.hk/aa_medal/index.asp" class="url"
                ><span style="">Academic Achievement Medal (top 1%)</span></a
            >, with <span class="text-highlight">double major</span> in Electronic Engineering and
            in Computer Science and <span class="text-highlight">triple minor</span> in Mathematics,
            in Big Data Technology, and in Humanities
            <a href="https://www.shss.ust.hk/ug/minor/hm/award/" class="url">(honoured)</a>.
            At HKUST,
            I have been the teaching assistant for 4 courses including data visualization, algorithms, VBA and python programming.
            <br /><br />

            -->
        </p>
    </div>
</template>

<script lang="ts">
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        return {
            ...toRefs(state),
        };
    },
    computed: {},
});
</script>

<style rel="stylesheet" lang="scss">
$color1: #96351e;

#sec-intro {
    a {
        color: $color1;
        text-decoration: none;
    }
}
</style>
